/**
 * Single source of truth for the timeline working window.
 *
 * Visual de-emphasis + drag snap/clamp use these hours.
 * Backend schedule engine currently uses 09:00 + 8h (until 17:00) in
 * `userCapacityModel.js` — do not change that API without an explicit
 * backend decision. This UI window is 10:00–21:00 (9 PM) as specified
 * for the timeline chrome.
 */
export const TIMELINE_WORKING_HOURS = {
    startHour: 10,
    endHour: 21,
    snapMinutes: 120,
};

export const isWorkingHour = (hour) => {
    const { startHour, endHour } = TIMELINE_WORKING_HOURS;
    return hour >= startHour && hour < endHour;
};
